import { render, staticRenderFns } from "./EnvSwitch.vue?vue&type=template&id=04e75462&scoped=true&"
import script from "./EnvSwitch.vue?vue&type=script&lang=js&"
export * from "./EnvSwitch.vue?vue&type=script&lang=js&"
import style0 from "./EnvSwitch.vue?vue&type=style&index=0&id=04e75462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e75462",
  null
  
)

export default component.exports